<template>
  <el-dialog :visible.sync="dialogVisible" title="充值" width="450px" center>
    <el-form ref="returnMoneyModal" :model="form" label-suffix=":" class="payFormModal" label-width="120px">
      <div class="tit mb10">商户号可分配金额：￥{{ $formatCurrency(form.mch_price) || '0.00' }}</div>
      <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id" class="mch-item">
        <el-form-item :label="`${mch_list.type == 1 ? '微信' : '支付宝'}商户号${index + 1}`">
          {{ mch_list.mch_id }}
        </el-form-item>
        <el-form-item
          label="充值金额"
          :prop="'mch_list.' + index + '.price'"
          :rules="{
            required: true, message: '充值金额不能为空', trigger: 'blur'
          }"
        >
          <el-input v-model="mch_list.price" class="w200" @input="(val) => changeValue(val, index)" />
        </el-form-item>
      </div>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFn('returnMoneyModal')">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        mch_price: '',
        mch_list: [] // 分配商户号金额
      }
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      if (!value) {
        // 重置
        this.form.mch_list = [] // 分配商户号金额
        this.form.mch_price = ''
        this.$emit('update:visible', false)
      }
    },
    source: {
      handler(val) {
        this.form = {
          ...this.form,
          ...val
        }
      },
      deep: true
    }
  },
  methods: {
    async submitFn(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (+this.form.mch_price / 100 !== sum) {
        this.$message({ type: 'error', message: '商户号充值金额与商户号充值可分配金额不相等!' })
        return
      }
      this.$emit('submitFn', this.form.mch_list)
    },
    changeValue(val, i) {
      this.form.mch_list[i].price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-form-item{
    margin-bottom: 10px;
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
}
.payFormModal .tit{
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.mch-item{
  background: #FAFAFA;
  padding:  10px 0;
  margin-bottom: 10px;
  &:last-child{
    margin-bottom: 0;
  }
}

</style>
